module.exports = __webpack_public_path__ + "static/BrandonGrotesque-SemiBold-0f53072d32c4a625e5878696e19303a4.woff2";